import { TypePermissionEntity } from "@/data/default/types/enumPermission";
import { RouteConfig } from "vue-router";
import RouterDirector from "@/data/default/types/RouterDirector";

const builder = RouterDirector.makeRouterWithPermission({
  name: "ocorrencias",
  permissionEntity: TypePermissionEntity.OCORRENCIA,
  componentRoot: () => import("@/screens/default/ocorrencias/Index.vue"),
  componentList: () => import("@/screens/default/ocorrencias/List.vue")
});

export const Router: RouteConfig[] = [builder.getRootRoute()];

export const routes = builder.getRouteNames();
